import { CogIcon, Modal, ModalContent } from './LoaderWithPageOverlayStyle';
import { pageLoaderState } from '../../constants/loader';
import { useEffect, useState } from 'react';

function LoaderWithPageOverlay() {
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : 'visible';
  }, [open]);

  useEffect(() => {
    const subscription = pageLoaderState.subscribe((value) => {
      setOpen(value.size > 0);
    });
    return () => subscription.unsubscribe();
  }, []);

  return (
    <Modal open={open}>
      <ModalContent>
        <CogIcon />
      </ModalContent>
    </Modal>
  );
}

export default LoaderWithPageOverlay;
